import React, { useState } from "react";
import { Search, X, Users } from "lucide-react";

export const GroupSelectModal = ({ isOpen, onClose, onSelect, groups }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);

  if (!isOpen) return null;

  const filteredGroups = groups.filter((group) =>
    group.groupName.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const handleGroupSelection = (group) => {
    setSelectedGroup(group);
  };

  const handleNext = () => {
    if (selectedGroup) {
      onSelect(selectedGroup);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-96 rounded-3xl bg-white">
        <div className="p-6">
          <div className="mb-6 flex items-center justify-between">
            <h2 className="text-xl font-semibold">Select Group</h2>
            <button onClick={onClose} className="p-2">
              <X size={24} />
            </button>
          </div>

          <div className="relative mb-4">
            <Search
              className="absolute left-3 top-1/2 -translate-y-1/2 transform text-gray-400"
              size={20}
            />
            <input
              type="text"
              placeholder="Search group by name"
              className="w-full rounded-full border py-2 pl-10 pr-4"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          <div className="mb-6 max-h-96 space-y-3 overflow-y-auto">
            {filteredGroups.map((group) => (
              <div
                key={group.id}
                onClick={() => handleGroupSelection(group)}
                className={`cursor-pointer rounded-3xl border p-4 hover:bg-gray-50 ${
                  selectedGroup?.id === group.id
                    ? "border-2 border-[#14b82c] bg-gray-50"
                    : "border-[#14b82c]"
                }`}
              >
                <div className="flex items-center gap-4">
                  <img
                    src={group.imageUrl}
                    alt={group.groupName}
                    className="h-16 w-16 rounded-full object-cover"
                  />
                  <div className="flex-1">
                    <div className="flex items-center justify-between">
                      <h3 className="font-medium">{group.groupName}</h3>
                      {group.isPremium && (
                        <span className="rounded-full bg-[#14b82c] px-3 py-1 text-sm text-white">
                          bammbuu+
                        </span>
                      )}
                    </div>
                    <div className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                      <span className="flex items-center">
                        {group.groupLearningLanguage === "English"
                          ? "🇺🇸"
                          : group.groupLearningLanguage === "Spanish"
                            ? "🇪🇸"
                            : "🌍"}{" "}
                        {group.groupLearningLanguage}
                      </span>
                      <span className="flex items-center gap-1">
                        <Users size={15} />
                        {group.memberIds ? group.memberIds.length : 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-between gap-4">
            <button
              onClick={onClose}
              className="flex-1 rounded-full border border-[#042f0c] py-3 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleNext}
              disabled={!selectedGroup}
              className={`flex-1 rounded-full border border-[#042f0c] py-3 text-black ${
                selectedGroup
                  ? "bg-[#14b82c] hover:bg-[#3edb56]"
                  : "cursor-not-allowed bg-gray-300"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ClassTypeModal = ({ isOpen, onClose, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-96 rounded-3xl bg-white p-6">
        <div className="flex flex-col items-center space-y-6">
          <div className="flex w-full justify-end">
            <button onClick={onClose} className="p-2">
              <X size={24} />
            </button>
          </div>
          <img alt="bambuu" src="/images/classType.png" />

          <h2 className="text-center text-xl font-semibold">
            Select form of class you want to create.
          </h2>

          <div className="w-full space-y-3">
            <button
              onClick={() => onSelect("group")}
              className="w-full rounded-full border border-black py-3 text-center hover:bg-gray-100"
            >
              Group Class
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
